<template>
  <div v-loading="loading"
       class="container_nopadding myIndex">
    <div class="banner">
      <img v-if="wWidth > 976 && $i18n.locale=='EN'"
           src="../../assets/web/banner_bg_EN.png" />
      <img v-if="wWidth > 976 && $i18n.locale=='PT'"
           src="../../assets/web/banner_bg_PT.png" />
      <img v-if="wWidth > 976 && ($i18n.locale=='ZH_TW' || $i18n.locale=='ZH_CN')"
           src="../../assets/web/banner_bg.png" />
      <img v-if="wWidth <= 976 && $i18n.locale=='EN'"
           src="../../assets/phone/banner_bg@3x_EN.png" />
      <img v-if="wWidth <= 976 && $i18n.locale=='PT'"
           src="../../assets/phone/banner_bg@3x_PT.png" />
      <img v-if="wWidth <= 976 && ($i18n.locale=='ZH_TW' || $i18n.locale=='ZH_CN')"
           src="../../assets/phone/banner_bg@3x.png" />
    </div>
    <div class="myIndex_content">
      <el-row :gutter="16">
        <el-col :xs="24"
                :sm="24"
                :md="16"
                :lg="16"
                :xl="16">
          <div class="summary">
            <div class="summary_course_title">{{course.title}}</div>
            <!-- <div v-html="last.course[`summary${$store.state.language}`]"></div> -->
            <div v-html="course.description"
                 class="html-box"></div>
          </div>
          <div class="course_mobile"
               v-if="$store.state.isMobile">
            <CourseCatalog :course="course"></CourseCatalog>
            <Questionnaire></Questionnaire>
          </div>
        </el-col>
        <el-col v-if="!$store.state.isMobile"
                :xs="24"
                :sm="24"
                :md="8"
                :lg="8"
                :xl="8">
          <CourseCatalog :course="course"></CourseCatalog>
          <Questionnaire></Questionnaire>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { Base64 } from "js-base64";
import CourseAPI from "../../api/CourseAPI";
import UserCourseAPI from "../../api/UserCourseAPI";
import UserAssessmentsAPI from "../../api/UserAssessmentsAPI";
import { serverUrl } from "../../api/axios";
import mBtn from "../../components/mBtn";
import CourseCatalog from "./CourseCatalog";
import Questionnaire from "../../components/Questionnaire";
export default {
  components: { mBtn, CourseCatalog, Questionnaire },
  data () {
    return {
      loading: false,
      testLoading: false,
      course: {},
      // questionnaire: [],
      serverUrl: serverUrl
    };
  },
  computed: {
    wWidth () {
      return this.$store.state.wWidth;
    }
  },
  methods: {
    handleCurrentChange (row) {
      console.log(row);
      if (this.$store.state.isPreview) return false;
      if (this.course.progress <= 0.8) {
        this.$alert(this.$t("message.question_tips"), this.$t("message.tips"), {
          confirmButtonText: this.$t("message.confirm"),
          callback: action => {
            console.log(action);
          }
        });
      } else {
        const code = Base64.encode(`id=${row.id}&type=user`);
        this.$router.push({
          path: "/question",
          query: {
            code: code
          }
        });
      }
    },
    // 打開連結
    openLink (link) {
      window.open(link);
    },
    get () {
      this.loading = true;
      const id = sessionStorage.getItem("courseId");
      const locale = this.$i18n.locale;
      if (this.$store.state.isPreview) {
        CourseAPI.getOne(id, locale)
          .then(res => {
            this.loading = false;
            this.course = res;
          })
          .catch(err => {
            this.loading = false;
            this.$error(err);
            console.log(err);
          });
      } else {
        Promise.all([
          CourseAPI.getOne(id, locale),
          // CourseAPI.listQuestionnaireByCourse(id, locale)
        ])
          .then(res => {
            this.loading = false;
            this.course = res[0];
            // this.questionnaire = res[1];
          })
          .catch(err => {
            this.loading = false;
            this.$error(err);
            console.log(err);
          });
      }
    }
  },
  created () {
    // }

    const id = sessionStorage.getItem("courseId");

    if (!id) {
      this.$router.push("/");
      return;
    }
    if (!this.$store.state.isPreview) {
      UserCourseAPI.addUserCourse(id)
        .then(res => {
          // console.log(res);
          this.last = res;
        })
        .catch(err => {
          this.$error(err);
          console.log(err);
        });
    }
    this.get();
  }
};
</script>

<style lang="scss" scoped>
.myIndex {
  overflow: hidden;
}
.course_mobile {
  margin: 14px 0;
}
.summary_course_title {
  background: #16b695;
  font-size: 20px;
  font-weight: 500;
  color: #fff;
  text-align: center;
  padding: 14px;
}
</style>